var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIngredientManagementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1604 11.8856H10.7059V14.0674H8.1604V11.8856ZM12.6149 11.8856H15.1604V14.0674H12.6149V11.8856ZM8.1604 8.06738H10.7059V10.2492H8.1604V8.06738ZM12.6149 8.06738H15.1604V10.2492H12.6149V8.06738Z",
    fill: "url(#paint0_linear_2426_35422)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1604 4.20375H11.5604V1.84011C11.5604 0.835565 10.7804 0.0673828 9.7604 0.0673828H6.1604C5.1404 0.0673828 4.3604 0.835565 4.3604 1.84011V4.20375H0.7604C0.4004 4.20375 0.1604 4.44011 0.1604 4.79466V4.91284L1.3004 12.0628C1.3604 12.6537 1.9004 13.0674 2.5004 13.0674H7.3604V11.8856H2.5004L1.4804 5.38556H15.1604V4.20375ZM5.5604 1.84011C5.5604 1.48556 5.8004 1.2492 6.1604 1.2492H9.7604C10.1204 1.2492 10.3604 1.48556 10.3604 1.84011V4.20375H5.5604V1.84011Z",
    fill: "url(#paint1_linear_2426_35422)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2426_35422",
    x1: 11.6604,
    y1: 8.06738,
    x2: 11.6604,
    y2: 14.0674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2426_35422",
    x1: 7.6604,
    y1: 0.0673828,
    x2: 7.6604,
    y2: 13.0674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientManagementIcon);
export default __webpack_public_path__ + "static/media/IngredientManagement_Icon.7aae85642201503822dc7cb1539e1df6.svg";
export { ForwardRef as ReactComponent };